import React from 'react'
import { Input } from '@fluentui/react-components'
import { t } from '../../../i18n/i18n'
import { Control, Controller } from 'react-hook-form'
import { Field } from './Field'


type ControlledPhoneInputProps = {
   name: any
   control: Control<any>
   label?: string
   disabled?: boolean
   required?: boolean
}
export const ControlledPhoneInput = ({ name, control, label, disabled, required }: ControlledPhoneInputProps) => {
   const formatToPhoneNumber = (value: string) => {
      if (value.startsWith('+')) {
         const digits = value.slice(1).replace(/\D/g, '').slice(0, 13)
         const parts = [digits.slice(0, 2), digits.slice(2, 5), digits.slice(5, 8), digits.slice(8)].filter(Boolean)
         return '+' + parts.join(' ')
      }
      const cleaned = value.replace(/\D/g, '').slice(0, 10)
      const parts = [cleaned.slice(0, 3), cleaned.slice(3, 6), cleaned.slice(6, 8), cleaned.slice(8, 10)].filter(Boolean)
      return parts.join(' ')
   }

   return (
      <Controller
         name={name}
         control={control}
         rules={{
            required: required ? t('RequiredField') : false,
            validate: (value) => {
               if (!value) return true
               if (value.startsWith('+')) {
                  const digits = value.slice(1).replace(/\D/g, '')
                  return digits.length >= 7 && digits.length <= 13 ? true : t('InvalidPhoneNumber')
               }
               return value.length >= 8 && value.length <= 10 ? true : t('InvalidPhoneNumber')
            },
         }}
         render={({ field: { value, onChange }, fieldState: { error } }) => {
            return (
               <Field label={label} required={required ?? false} validationMessage={error ? error.message : null} validationState={error ? 'error' : null}>
                  <Input
                     type="text"
                     value={value ? formatToPhoneNumber(value.toString()) : ''}
                     onChange={(e, data) => {
                        if (data.value.startsWith('+')) {
                           const digits = data.value.slice(1).replace(/\D/g, '').replace(/^0/, '').slice(0, 13)
                           onChange('+' + digits)
                        } else {
                           onChange(data.value.replace(/\D/g, '').slice(0, 10))
                        }
                     }}
                     disabled={disabled ?? false}
                  />
               </Field>
            )
         }}
      />
   )
}
